import {
  Grommet, Box,Main,
} from 'grommet';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useAppContext from '../Context/useAppContext';
import grommetTheme from './grommetTheme';
import AppHeader from '../AppHeader/AppHeader';
import AppSidebar from '../AppSidebar/AppSidebar';
import ToastContainerConfig from '../ToastContainerConfig/ToastContainerConfig';
import onGoTop from '../../../Utils/onGoTop';
export interface GrommetWrapperProps {
  children: JSX.Element;
}

const GrommetWrapper: React.FC<GrommetWrapperProps> = ({ children }): JSX.Element => {
  const {
    state: { Theme, IsAuthenticated },
  } = useAppContext();

  const location = useLocation();

  useEffect((): void => {
    onGoTop();
  }, [location]);

  return (
    <Grommet
      theme={grommetTheme}
      themeMode={(Theme === 'light') ? 'light' : 'dark'}
      full
    >
      <ToastContainerConfig />
      <Box direction="row" fill>
        <AppSidebar />

        <Box flex direction="column" fill>
          {/* Header */}
          {
            (!IsAuthenticated) && <AppHeader />
          }

          {/* Body */}
          <Main pad="medium" flex overflow="auto">
            {children}
          </Main>
        </Box>
      </Box>
    </Grommet>
  );
};

GrommetWrapper.displayName = 'GrommetWrapper';

export default GrommetWrapper;
